module.exports = {
  // INDEX: 'http://192.168.3.8:8088',
  INDEX: 'https://test-mobile-cauc-anniversary.sayeasytech.com',//民航
  // INDEX: 'https://alu.cauc.edu.cn', // 民航正式
  // APPID: 'wx8f4e3f68c7c7efc8' // 测试服
  // INDEX: 'https://sjw.shuzixiangcun.sayeasytech.com', // 正式服
  // APPID: 'wxcc8226ed965699d9', // 智慧乡村正式服
  APPID: 'wxf2e8981129fb808a', // 易暖心正式服
  // APPID: 'wxc6af535ecb6c8eb0', // 民航大学正式服
}



// WEBPACK FOOTER //
// ./src/utils/target.js